import React from 'react'
import EnqueryImage from '../../assets/HomeImage.png'

export const Enquery = () => {
  return (
      <section class="w-full bg-white py-10 md:px-0 px-4">
          <div class="max-w-7xl mx-auto  grid grid-cols-1 md:grid-cols-2 gap-10 items-center border rounded-xl " >
              <div className='px-10'>
                  <h2 class="text-4xl md:text-5xl font-bold text-gray-900 leading-tight">
                      Get your project<br />started
                  </h2>

                  <p class="mt-4 text-gray-600 max-w-md">
                      Tell us about your industrial needs and we’ll provide a
                      tailored solution to get your project moving.
                  </p>
                  
                  <div className="mt-6 flex gap-4 items-center w-full">
                      <input
                          type="email"
                          placeholder="Your email address"
                          className="w-full border border-gray-300 rounded-lg py-2 px-4 
                          focus:outline-none focus:ring-2 focus:ring-primary-500"
                      />
                      <button
                          className="bg-primary-500 text-white px-6 py-2 rounded-lg 
                        hover:bg-primary-600 transition whitespace-nowrap"
                      >
                          Send Enquiry
                      </button>
                  </div>
              </div>
              <div class="relative">
                  <img
                      src={EnqueryImage}
                      alt="project start"
                      class="w-full h-[300px] md:h-[350px] object-cover rounded-r-xl shadow"
                  />
              </div>
          </div>
      </section>
  )
}
